import { render } from "./SpecialItem.vue?vue&type=template&id=ebcfdb6e&scoped=true"
import script from "./SpecialItem.vue?vue&type=script&lang=js"
export * from "./SpecialItem.vue?vue&type=script&lang=js"

import "./SpecialItem.vue?vue&type=style&index=0&id=ebcfdb6e&scoped=true&lang=css"

import exportComponent from "/Users/pongsakornsomsri/workspace/neera-retreat-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebcfdb6e"]])

export default __exports__